<div>
  <ngx-datatable
    #myTable
    class="material clickable"
    [headerHeight]="45"
    [rows]="loading ? skeletonRows : automations"
    [scrollbarV]="false"
    [scrollbarH]="true"
    [footerHeight]="0"
    [columnMode]="'force'"
    [rowHeight]="60"
    [externalPaging]="false"
    [count]="loading ? skeletonRows.length : automations.length"
    (activate)="!loading && onRowActivate($event)"
    [messages]="{
      emptyMessage: 'No automations',
    }"
  >
    <ngx-datatable-column name="Name" [resizeable]="false">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span
          *ngIf="row?.__loading; else automationName"
          class="table-cell-shimmer table-cell-shimmer-wide"
        ></span>
        <ng-template #automationName>
          <div class="automation-name">
            {{ row.name }}
          </div>
        </ng-template>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Action" [resizeable]="false" [width]="180">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span
          *ngIf="row?.__loading; else automationAction"
          class="table-cell-shimmer"
        ></span>
        <ng-template #automationAction>
          <div class="action-display">
            <mat-icon *ngIf="row.action?.message" class="action-icon"
              >notifications</mat-icon
            >
            <mat-icon
              *ngIf="row.action?.rewards?.length || row.action?.reward"
              class="action-icon"
              >card_giftcard</mat-icon
            >
            <span
              *ngIf="
                row.action?.message &&
                (row.action?.rewards?.length || row.action?.reward)
              "
            >
              Push + Reward
            </span>
            <span
              *ngIf="
                row.action?.message &&
                !(row.action?.rewards?.length || row.action?.reward)
              "
            >
              Push Notification
            </span>
            <span
              *ngIf="
                !row.action?.message &&
                (row.action?.rewards?.length || row.action?.reward)
              "
            >
              Give Reward
            </span>
          </div>
        </ng-template>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Trigger" [resizeable]="false" [width]="220">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span
          *ngIf="row?.__loading; else automationTrigger"
          class="table-cell-shimmer table-cell-shimmer-wide"
        ></span>
        <ng-template #automationTrigger>
          {{ getTriggerDisplay(row) }}
        </ng-template>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Last Run" [resizeable]="false" [width]="160">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span
          *ngIf="row?.__loading; else automationLastRun"
          class="table-cell-shimmer"
        ></span>
        <ng-template #automationLastRun>
          <div class="last-run">
            <div *ngIf="row.frequency?.lastExecuted" class="last-run-date">
              {{ row.frequency.lastExecuted | date: "dd/MM/yy HH:mm" }}
            </div>
            <div *ngIf="!row.frequency?.lastExecuted" class="text-muted">
              Never
            </div>
            <div
              *ngIf="
                row.lastExecutionResult &&
                row.lastExecutionResult.recipientCount !== undefined
              "
              class="recipient-count"
            >
              {{ row.lastExecutionResult.recipientCount }} recipients
            </div>
          </div>
        </ng-template>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Next Run" [resizeable]="false" [width]="200">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span
          *ngIf="row?.__loading; else automationNextRun"
          class="table-cell-shimmer"
        ></span>
        <ng-template #automationNextRun>
          <div class="next-run">
            <div class="next-run-content">
              <div
                *ngIf="
                  row.frequency?.nextExecution &&
                  row.frequency?.type !== 'milestone' &&
                  isScheduleAutomation(row)
                "
                class="next-run-date"
              >
                {{ row.frequency.nextExecution | date: "dd/MM/yy HH:mm" }}
              </div>
              <div
                *ngIf="
                  !row.frequency?.nextExecution ||
                  row.frequency?.type === 'milestone' ||
                  !isScheduleAutomation(row)
                "
                class="text-muted"
              >
                <span *ngIf="row.frequency?.type === 'milestone'"
                  >On milestone</span
                >
                <span *ngIf="!isScheduleAutomation(row)">On trigger</span>
                <span
                  *ngIf="
                    row.frequency?.type !== 'milestone' &&
                    isScheduleAutomation(row)
                  "
                  >-</span
                >
              </div>
            </div>
            <button
              *ngIf="isScheduleAutomation(row)"
              mat-icon-button
              class="preview-button"
              (click)="previewRecipients(row, $event)"
              matTooltip="Preview recipients"
            >
              <mat-icon>visibility</mat-icon>
            </button>
          </div>
        </ng-template>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Status" [resizeable]="false" [width]="100">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span
          *ngIf="row?.__loading; else automationStatus"
          class="table-cell-shimmer table-cell-shimmer-toggle"
        ></span>
        <ng-template #automationStatus>
          <div (click)="$event.stopPropagation()">
            <mat-slide-toggle
              [checked]="row.enabled"
              (change)="toggleEnabled(row)"
              color="primary"
            ></mat-slide-toggle>
          </div>
        </ng-template>
      </ng-template>
    </ngx-datatable-column>

    <ngx-datatable-column name="Actions" [resizeable]="false" [width]="120">
      <ng-template let-row="row" ngx-datatable-cell-template>
        <span
          *ngIf="row?.__loading; else automationActions"
          class="table-cell-shimmer table-cell-shimmer-actions"
        ></span>
        <ng-template #automationActions>
          <div class="action-buttons">
            <button
              mat-icon-button
              (click)="editAutomation(row); $event.stopPropagation()"
              matTooltip="Edit"
            >
              <mat-icon>edit</mat-icon>
            </button>
            <button
              mat-icon-button
              (click)="deleteAutomation(row); $event.stopPropagation()"
              matTooltip="Delete"
              color="warn"
            >
              <mat-icon>delete</mat-icon>
            </button>
          </div>
        </ng-template>
      </ng-template>
    </ngx-datatable-column>
  </ngx-datatable>
</div>
